// src/reducers/authReducer.js
const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: localStorage.getItem('isAuthenticated') === 'true',
  user: JSON.parse(localStorage.getItem('user')),
  error: null
};

export default function(state = initialState, action) {
  switch(action.type) {
    case 'LOGIN_SUCCESS':
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      return {
        ...state,
        token: action.payload.token,
        isAuthenticated: true,
        user: action.payload.user,
        error: null
      };
    case 'LOGIN_FAIL':
    case 'LOGOUT':
      localStorage.removeItem('token');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('user');
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: null,
        error: action.payload
      };
    case 'UPDATE_AUTH_BALANCE': {
      if (!state.user) {
        return state;
      }
      const updatedUser = {
        ...state.user,
        balance: action.payload
      };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      return {
        ...state,
        user: updatedUser
      };
    }
    case 'SET_USER_PRIVILEGES': {
      if (!state.user) {
        return state;
      }
      const updatedUser = {
        ...state.user,
        privileges: action.payload || {}
      };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      return {
        ...state,
        user: updatedUser
      };
    }
    case 'SET_USER_FIELD_PRIVILEGES': {
      if (!state.user) {
        return state;
      }
      const updatedUser = {
        ...state.user,
        fieldPrivileges: action.payload || {}
      };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      return {
        ...state,
        user: updatedUser
      };
    }
    default:
      return state;
  }
}